import Vue from 'vue';
import Vuex from 'vuex';

import { auth } from './auth.module'
import { notes } from './notes.module'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    auth,
    notes
  }
})


// WEBPACK FOOTER //
// ./src/_store/index.js